import { FormControl, TextField } from '@mui/material';
import { ConfigEntryType } from 'config/config';
import { Controller, useFormContext } from 'react-hook-form';
import { CustomIMaskInput } from './CustomIMaskInput';

type PhoneNumberInputFieldProps = {
  field: ConfigEntryType;
};

function PhoneNumberInputField({ field }: PhoneNumberInputFieldProps) {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<Record<string, any>>();

  return (
    <Controller
      control={control}
      name={field.entryCode}
      render={({ field: _field, fieldState }) => (
        <FormControl fullWidth sx={{ my: 1 }}>
          <TextField
            {..._field}
            size="small"
            value={!!_field?.value?.trim() ? _field.value : ''}
            InputProps={{
              inputComponent: CustomIMaskInput as any,
            }}
            fullWidth
            placeholder={field.referenceObject?.placeHolder || 'Enter value'}
            variant="standard"
            error={!!fieldState.error}
            helperText={fieldState?.error?.message || ''}
            InputLabelProps={{ shrink: true }}
            disabled={isSubmitting}
          />
        </FormControl>
      )}
    />
  );
}

export default PhoneNumberInputField;
